import axios from 'axios';

const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

export const setAuthToken = (token) => {
  if (token) {
    axiosInstance.defaults.headers['Authorization'] = `JWT ${token}`;
    axiosInstance.defaults.headers.common.Accept = 'application/json';
  } else {
    delete axiosInstance.defaults.headers['Authorization'];
  }
};

export default axiosInstance;
